import { COMPANY_TYPE, ICompany } from '../../../domain/company/interface';

export const filterCompaniesByType = (companies: ICompany[], type: COMPANY_TYPE) => companies.filter(c => c.type === type);

export const transformCompaniesToSelectOption = (companies: ICompany[]) =>
    companies.map(company => ({ label: company.company_name, value: company.company_id }));
